/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../constants'

import AddForm from './addForm'
import ViewDetails from './viewDetails'
import UserName from '../../components/Custom/UserNameLabel'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedBlotter: null,
			// complain_status: [],
			isViewDetailShown: false,
			selectedBlotterUid: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// complain_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, barangay_term_uid, user_type } = AuthStore
		const isAdmin = _.isEqual(RoleCode.SUPERADMIN, user_type) || _.isEqual(RoleCode.SYSTEMADMIN, user_type)
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedBlotter,
			isViewDetailShown, selectedBlotterUid
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					{
						!barangay_term_uid &&
						<div className="alert alert-icon alert-danger alert-dismissible fade show" role="alert">
							<i className="mdi mdi-block-helper mr-2"></i>
							<strong>Warning!</strong>  Barangay Term not defined in the system, please check your setup in Utilities > Data Lookup Management module.
						</div>
					}
					<Row>
						{
							barangay_term_uid &&
							<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
								this.setState({ isAddFormShown: true, isEdit: false, selectedBlotter: null })
							}} style={{ float: 'right' }}>New Blotter</button>
						}
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_BLOTTERS} 
							variables={{ searchFilter: filters, barangay_uid }}
							fetchPolicy='network-only'
						>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let barangayBlotters = _.has(data,'barangayBlotters') ? data.barangayBlotters.data : []
								barangayBlotters = barangayBlotters.map((barangayBlotter, key) => Object.assign({}, barangayBlotter, { key }))
								let _pagination = _.has(data, 'barangayBlotters') ? data.barangayBlotters.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [{
									title: 'Complainant(s)',
									key: 'complainant_name',
									render: (record) => {
										const complainants = record.complainants.map(i => i.complainant_name).join(', ')
										return (
											<span>{complainants}</span>
										)
									}
								}, {
									title: 'Respondent(s)',
									key: 'respondent_name',
									render: (record) => {
										const respondents = record.respondents.map(i => i.respondent_name).join(', ')
										return (
											<span>{respondents}</span>
										)
									}
								}, {
									title: 'Remarks',
									key: 'remarks',
									dataIndex: 'remarks'
								}, {
									title: 'Date Filed',
									key: 'complain_date',
									render: (record) => {
										return (
											<span>{moment(record.complain_date).format('lll')}</span>
										)
									}
								}, {
									title: 'Created By',
									key: 'created_by',
									render: (record) => {
										return (
											<UserName user_uid={record.created_by}/>
										)
									}
								}, {
									title: 'Action',
									key: 'action',
									width: 200,
									render: (record) => {
										if (_.isEqual(record.status, 'Filed as blotter')) {
											return <i style={{ color: 'red' }}>Case moved in blotter</i>
										} else {
											return (
												<React.Fragment>
													<Link 
														// to={{ pathname: `/complains/details/${record.uid}`, state: { complain_uid: record.uid } }} 
														to={`/blotter/details/${record.uid}`}
														style={{ marginRight: 10 }}
													>
														View Details
													</Link>
													<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedBlotter: record })}>Edit</a>
													{
														isAdmin &&
														<Popconfirm
															title="Are you sure delete this blotter?"
															onConfirm={() => {
																const { deleteBlotter } = this.props
																deleteBlotter({ blotter_uid: record.uid })
																	.then((response) => {
																		message.success('Blotter successfully deleted.')

																		//create audit trail
																		const auditParams = {
																			module_name: 'Blotter',
																			action: 'Delete',
																			message: 'Deleted blotter'
																		}
																		AuthStore.saveAuditTrail(auditParams)
																	}).catch(err => {
																		console.log('error deleting blotter', err)
																		message.error(err.message.replace('GraphQL error:', ''))
																	})
															}}
															// onCancel={cancel}
															okText="Yes"
															cancelText="No"
														>
															<a href="javascript:void(0)" >Delete</a>
														</Popconfirm>
													}
												</React.Fragment>
											)
										}
									}
								}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={barangayBlotters} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedBlotter={selectedBlotter}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedBlotter: null })}
                        />
					}
					{
						isViewDetailShown &&
						<ViewDetails 
							blotter_uid={selectedBlotterUid}
							visible={isViewDetailShown}
							onCancel={() => this.setState({ isViewDetailShown: false, selectedBlotterUid: null })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_BLOTTERS = gql`
    query barangayBlotters($barangay_uid: String, $searchFilter: SearchParams) {
		barangayBlotters(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_BLOTTER = gql`
    mutation deleteBlotter($input: JSON) {
		deleteBlotter(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_BLOTTER, {
		props({ mutate }) {
			return {
				deleteBlotter(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayBlotters']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
